import React, { Component, Fragment } from 'react';
import { Row, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    getUserList,
    getRoleList,
    getPropertyList,
} from '../../../../../redux/actions';
import {
    gAPI_Internal_Property_By_Id,
    postAPI_TrackEvent,
} from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import ContactsForm from '../../../pages/admin/components/forms/ContactsForm';
import IntlMessages from '../../../../../helpers/IntlMessages';

class SubscribeToReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contacts: null,
            editContact: false,
            name: '',
        };
    }

    componentDidMount() {
        // this.props.getUserList();
        if (this.props.email !== '') {
            AxiosAPI({
                method: 'post',
                url: `${postAPI_TrackEvent}`,
                data: {
                    eventName: 'Dashboard Users and Admin',
                    email: this.props.email,
                },
            }).then(
                (res) => { },
                (error) => {
                    console.log(error);
                }
            );
        }
        if (this.props.propertyId !== '-1') {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId
                    }?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    this.setState({ contacts: res.data.contacts, name: res.data.name });
                })
                .catch((err) => console.error(err));
        }
    }

    render() {
        return (
            <Fragment>
                <div className="mb-2">

                    {this.props.propertyId !== '-1' && (

                        <div className="d-block d-md-inline-block  ml-2">
                            <Button
                                color="primary"
                                outline
                                size="xs"
                                onClick={() => this.setState({ editContact: true })}
                                className="top-right-button mr-1"
                            // style={{ width: '100%', borderRadius: '6px' }}
                            >
                                + <IntlMessages id='dashboards.subscribe-to-reports' />
                            </Button>

                            {this.state.editContact && (
                                <ContactsForm
                                    contacts={this.state.contacts}
                                    id={this.props.propertyId}
                                    name={this.state.name}
                                    visible={this.state.editContact}
                                    toggle={() =>
                                        this.setState({
                                            editContact: !this.state.editContact,
                                        })
                                    }
                                />
                            )}
                        </div>
                    )}


                </div>


            </Fragment>
        );
    }
}
const mapStateToProps = ({ usersListApp, settings }) => {
    const { propertyId, email } = settings;
    return {
        usersListApp,
        propertyId,
        email,
    };
};
export default injectIntl(
    connect(mapStateToProps, {
        getUserList,
        getRoleList,
        getPropertyList,
    })(SubscribeToReports)
);
